export const copyJSON = <T>(value: T) => JSON.parse(JSON.stringify(value)) as T;

export const supportContactEmail = 'support@assistancekaren.se';
